<template>
  <div class="app-router">
    <h2 class="font-weight-bold pb-5">Tambah Produk</h2>
    <div class="d-block text-subtitle-2 pb-3">
      Pastikan produk Anda sudah sesuai dengan syarat dan ketentuan HWI Ecommerce. 
      HWI Ecommerce menghimbau seller untuk menjual produk dengan harga yang wajar atau produk Anda dapat diturunkan oleh HWI Ecommerce sesuai S&K yang berlaku.
    </div>

    <v-form ref="formAddProduct" role="form">
      <v-card outlined class="px-3 py-3 my-5">
        <v-card-title class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4">
          Informasi Produk
        </v-card-title>
        <v-card-text class="px-2">
          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Pilih Produk HWI
                <v-chip
                  x-small
                  class="ma-2 py-2 font-weight-bold"
                  color="green"
                  outlined
                >
                  Wajib
                </v-chip>
              </div>
              <!-- <p class="mb-0 text-caption grey--text">Nama min. 5 karakter, terdiri dari jenis produk, merek, dan keterangan seperti warna, bahan, atau tipe.</p> -->
            </v-col>
            <v-col cols="12" sm="8" class="pb0-xs">
              <v-autocomplete
                :rules="categoryRules"
                v-model="produkInput.kategori"
                :items="productSamples"
                item-value="product_id"
                item-text="product_name"
                placeholder="Pilih Produk"
                hide-details="auto"
                :auto-select-first="true"
                outlined
                dense
                :error-messages="responseError.category"
                @focus="() => responseError.category=''"
              ></v-autocomplete>
            </v-col>
          </v-row>

        </v-card-text>
      </v-card>
      
      <v-card outlined class="px-3 py-3 my-5" v-if="$route.name == 'stokis-produk-tambah'">
        <v-card-title class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4">
          Upload Gambar Produk 
          <!-- <v-chip
            small
            class="ma-2"
            color="green"
            outlined
          >
            Wajib
          </v-chip> -->
        </v-card-title>
        <v-card-text class="px-2">
          <div class="text-caption">
            Format gambar .jpg .jpeg .png dan ukuran minimum 300 x 300 px (Untuk gambar optimal gunakan minimum 700 x 700 px)
          </div>
          <div class="text-center mt-3" v-if="image_alert">
            <v-alert class=" white--text red lighten-1" dense dismissible @input="toggleAlert" v-model="image_alert">Produk harus disertai gambar</v-alert>
          </div>

          <v-row class="my-5 d-flex align-center justify-center flex-row">
            <v-col cols="4" sm="2" v-for="(img, idg) in imgProduct" :key="idg">
              <div class="product-img d-row outlined py-4 px-4" :class="img ? '' : 'emptyImg'">
                <v-img width="100%" :src="img ? img : '/assets/seller/add-image-icon.svg'"></v-img>
                <v-btn
                  v-if="img"
                  class="mx-0 close-btn"
                  fab
                  dark
                  x-small
                  color="red"
                  @click="removeImage(idg)"
                >
                  <v-icon dark>
                    mdi-close
                  </v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>

          <div v-show="false">
            <v-file-input
              @change="createImage($event)"
              id="inputProdukImg"
              ref="fileupload"
              chips
              accept="image/*"
              multiple
              small-chips
              prepend-icon=""
              truncate-length="50"
            ></v-file-input>
          </div>
          <div class="v-row d-flex flex-column align-center">
            <v-btn
              color="success"
              elevation="2"
              dark
              min-width="140"
              class="my-3"
              @click="openUpload"
            >
              <strong class="text-capitalize text-subtitle-2 font-weight-bold"><v-icon color="white darken-1 mr-2">mdi-plus</v-icon> Pilih Gambar Produk</strong>
            </v-btn>

            <!-- <v-btn
              color="warning"
              elevation="2"
              dark
              min-width="140"
              class="my-3"
              v-else
            >
              <strong class="text-capitalize text-subtitle-2 font-weight-bold"><v-icon color="white darken-1 mr-2">mdi-upload</v-icon> Upload Produk</strong>
            </v-btn> -->
            <div class="text-caption font-weight-bold">
              Letakkan hingga 5 gambar sekaligus disini.
            </div>
          </div>
        </v-card-text>
      </v-card>

      <v-card outlined class="px-3 py-3 my-5" v-if="false">
        <v-card-title class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4">
          Informasi Produk
        </v-card-title>
        <v-card-text class="px-2">
          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Nama Produk
                <v-chip
                  x-small
                  class="ma-2 py-2 font-weight-bold"
                  color="green"
                  outlined
                >
                  Wajib
                </v-chip>
              </div>
              <p class="mb-0 text-caption grey--text">Nama min. 5 karakter, terdiri dari jenis produk, merek, dan keterangan seperti warna, bahan, atau tipe.</p>
            </v-col>
            <v-col cols="12" sm="8" class="pb0-xs">
              <v-text-field
                :rules="nameRules"
                v-model="produkInput.nama"
                outlined
                small
                dense
                counter="70"
                placeholder="Masukkan nama produk"
                :error-messages="responseError.name"
                @focus="() => responseError.name=''"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4" class="py-0">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Kategori
                <v-chip
                  x-small
                  class="ma-2 py-2 font-weight-bold"
                  color="green"
                  outlined
                >
                  Wajib
                </v-chip>
              </div>
            </v-col>
            <v-col cols="12" sm="8" class="py-0">
              <v-autocomplete
                :rules="categoryRules"
                v-model="produkInput.kategori"
                :items="category"
                item-value="product_category_id"
                item-text="product_category_name"
                placeholder="Pilih Kategori"
                hide-details="auto"
                :auto-select-first="true"
                outlined
                dense
                :error-messages="responseError.category"
                @focus="() => responseError.category=''"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card outlined class="px-3 py-3 my-5">
        <v-card-title class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4">
          Detail Produk
        </v-card-title>
        <v-card-text class="px-2 pb-0">
          <v-row v-if="false">
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Kondisi
              </div>
            </v-col>
            <v-col cols="12" sm="8" class="pb0-xs">
              <v-radio-group
                v-model="produkInput.kondisi"
                hide-details="auto"
                row
              >
                <v-radio
                  label="Baru"
                  value="1"
                ></v-radio>
                <v-radio
                  label="Bekas"
                  value="0"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Satuan
              </div>
            </v-col>
            <v-col cols="12" sm="8" class="pb0-xs">
              <v-autocomplete
                v-model="produkInput.unit"
                :items="units"
                :rules="unitRules"
                placeholder="Satuan"
                hide-details="auto"
                outlined
                dense
                :error-messages="responseError.unit"
                @focus="() => responseError.unit=''"
              >
                <template v-slot:selection="{ item }">
                  <span class="text-capitalize">{{ item }}</span>
                </template>
                <template v-slot:item="{ item }">
                  <span class="text-capitalize">{{ item }}</span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-row>
            <v-col  cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Deskripsi Produk
              </div>
              <p class="mb-0 text-caption grey--text">Pastikan deskripsi produk memuat spesifikasi, ukuran, bahan, masa berlaku, dan lainnya. Semakin detail, semakin berguna bagi pembeli.</p>
            </v-col>
            <v-col  cols="12" sm="8" class="pb0-xs">
              <v-textarea
                v-model="produkInput.deskripsi"
                outlined
                small
                dense
                no-resize
                rows="5"
                counter="500"
                :error-messages="responseError.description"
                @focus="() => responseError.description=''"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card outlined class="px-3 py-3 my-5" v-if="detailStore">
        <v-card-title class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4">
          Harga Produk
        </v-card-title>
        <v-card-text class="px-2">
          <v-row v-if="false">
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Minimum Pemesanan
              </div>
              <p class="mb-0 text-caption grey--text">Atur jumlah minimum yang harus dibeli untuk produk ini.</p>
            </v-col>
            <v-col cols="12" sm="4" class="pb0-xs">
              <v-text-field
                v-model="produkInput.minOrder"
                outlined
                small
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Harga Jual Minimum
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="pb0-xs">
              <v-currency-field
                v-model="produkInput.hargaB2b"
                :rules="priceRules"
                outlined
                small
                dense
                placeholder="Masukkan harga"
                prefix="Rp"
                hide-details="auto"
                :error-messages="responseError.price"
                @focus="() => responseError.price=''"
                persistent-hint
                disabled
              ></v-currency-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Harga Jual
                <v-chip
                  x-small
                  class="ma-2 py-2 font-weight-bold"
                  color="green"
                  outlined
                >
                  Wajib
                </v-chip>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="pb0-xs">
              <v-currency-field
                v-model="produkInput.hargaSatuan"
                :rules="priceRules"
                outlined
                small
                dense
                placeholder="Masukkan harga"
                prefix="Rp"
                hide-details="auto"
                :error-messages="responseError.price"
                @focus="() => responseError.price=''"
                persistent-hint
                hint="Harga jual produk ke konsumen"
              ></v-currency-field>
            </v-col>
          </v-row>

          <v-row v-if="detailStore.store_is_b2b == 'true'">
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Harga B2B
                <v-chip
                  x-small
                  class="ma-2 py-2 font-weight-bold"
                  color="green"
                  outlined
                >
                  Wajib
                </v-chip>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="pb0-xs">
              <v-currency-field
                v-model="produkInput.hargaB2b"
                :rules="priceB2bRules"
                outlined
                small
                dense
                placeholder="Masukkan harga"
                prefix="Rp"
                hide-details="auto"
                :error-messages="responseError.price_original"
                @focus="() => responseError.price_original=''"
                persistent-hint
                hint="Harga jual dari perusahaan"
              ></v-currency-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card outlined class="px-3 py-3 my-5">
        <v-card-title class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4">
          Pengelolaan Produk
        </v-card-title>
        <v-card-text class="px-2">
          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Status Produk
              </div>
            </v-col>
            <v-col cols="12" sm="2" class="pb0-xs">
              <v-switch
                v-model="produkInput.status"
                class="my-0 py-0"
                inset
                hide-details="auto"
                true-value="active"
                false-value="inactive"
                dense
              ></v-switch>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Stok Produk
                <v-chip
                  x-small
                  class="ma-2 py-2 font-weight-bold"
                  color="green"
                  outlined
                >
                  Wajib
                </v-chip>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="pb0-xs">
              <v-currency-field
                v-model="produkInput.stok"
                :rules="stockRules"
                outlined
                small
                dense
                placeholder="Masukkan jumlah stok"
                hide-details="auto"
                :error-messages="responseError.quantity"
                @focus="() => responseError.quantity=''"
              ></v-currency-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card outlined class="px-3 py-3 my-5">
        <v-card-title class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4">
          Berat &amp; Pengiriman Produk
        </v-card-title>
        <v-card-text class="px-2">
          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Berat Produk
                <v-chip
                  x-small
                  class="ma-2 py-2 font-weight-bold"
                  color="green"
                  outlined
                >
                  Wajib
                </v-chip>
              </div>
              <p class="mb-0 text-caption grey--text">Masukkan berat dengan menimbang produk setelah dikemas.</p>
            </v-col>

            <v-col cols="12" sm="3" class="pb0-xs">
              <v-autocomplete
                v-model="produkInput.unitberat"
                :items="weightUnits"
                :rules="weightUnitRules"
                item-text="text"
                item-value="multiple"
                placeholder="Satuan"
                hide-details="auto"
                outlined
                dense
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="3" class="pb0-xs">
              <v-currency-field
                v-model="produkInput.berat"
                :rules="weightRules"
                outlined
                small
                dense
                hide-details="auto"
                placeholder="Masukkan berat"
                :decimalLength="2"
                :error-messages="responseError.weight"
                @focus="() => responseError.weight=''"
              ></v-currency-field>
            </v-col>
          </v-row>

          <v-row v-if="false">
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Asuransi Pengiriman
              </div>
              <p class="mb-0 text-caption grey--text">Gunakan asuransi pengiriman untuk menjamin kerugian, kerusakan, &amp; kehilangan selama pengiriman produk.</p>
            </v-col>
            <v-col cols="12" sm="8">
              <v-radio-group
                v-model="produkInput.asuransi"
                hide-details="auto"
                row
                class="my-0"
              >
                <v-radio
                  label="Opsional"
                  value="0"
                ></v-radio>
                <v-radio
                  label="Ya"
                  value="1"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

    </v-form>

    <v-layout v-resize="onResize" column>
      <v-card outlined class="px-3 py-3 my-5">
        <v-card-text>
          <v-row>
            <v-col cols="12" class="text-right py-0 px-0">
              <v-btn
                color="error"
                elevation="2"
                outlined
                dark
                min-width="140"
                :loading="loadingProcess"
                class="mr-2"
                v-if="!isMobile"
                @click="cancelForm"
              >
                <strong class="text-capitalize text-subtitle-2 font-weight-bold">Batal</strong>
              </v-btn>

              <v-btn
                color="success"
                elevation="2"
                outlined
                dark
                min-width="140"
                :loading="loadingProcess"
                :class="(isMobile) ? 'v-btn--block mb-3' : 'mr-2'"
                @click="save(1)"
                v-if="!isMobile"
              >
                <strong class="text-capitalize text-subtitle-2 font-weight-bold">Simpan &amp; Tambah Baru</strong>
              </v-btn>

              <v-btn
                color="success"
                elevation="2"
                dark
                min-width="140"
                :loading="loadingProcess"
                :class="(isMobile) ? 'v-btn--block mb-3' : ''"
                @click="save(2)"
              >
                <strong class="text-capitalize text-subtitle-2 font-weight-bold">Simpan</strong>
              </v-btn>

              <v-btn
                color="success"
                elevation="2"
                outlined
                dark
                :class="(isMobile) ? 'v-btn--block mb-3' : 'mr-2'"
                min-width="140"
                :loading="loadingProcess"
                @click="save(1)"
                v-if="isMobile"
              >
                <strong class="text-capitalize text-subtitle-2 font-weight-bold">Simpan &amp; Tambah Baru</strong>
              </v-btn>

              <v-btn
                color="error"
                elevation="2"
                outlined
                dark
                min-width="140"
                :loading="loadingProcess"
                :class="(isMobile) ? 'v-btn--block mb-3' : 'mr-2'"
                v-if="isMobile"
                @click="cancelForm"
              >
                <strong class="text-capitalize text-subtitle-2 font-weight-bold">Batal</strong>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-layout>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
const defaultInput = () => ({
  nama: 'HWI-C',
  slug: 'hwi-c',
  kategori: '1',
  kondisi: '1',
  deskripsi: 'Suplemen Vitamin C Generasi terbaru, Pureway-C, yang aman di lambung, mudah diserap dan bertahan lama di dalam tubuh sehingga dapat membantu menjaga daya tahan tubuh. Diperkaya dengan Vitamin D, Vitamin E, Zinc dan ekstrak alami Citrus Bioflavonoid, Rosehip, Acerola yang penting dalam penyerapan Vitamin C yang optimal.',
  minOrder: 1,
  hargaSatuan: 408000,
  hargaB2b: 408000,
  status: 'active',
  stok: 10,
  berat: 100,
  unitberat: {text: 'Gram (g)', multiple: 1},
  unit: 'pcs',
  asuransi: 0,
  image: []
})
export default {
  data() {
    return {
      title: '',
      image_alert: false,
      isMobile: false,
      loadingProcess: false,
      nameRules: [
        v => !!v || 'Nama produk tidak boleh kosong',
        v => v.length >= 5 || 'Nama produk minimal 5 karakter',
      ],
      unitRules: [
        v => !!v || 'Satuan produk tidak boleh kosong',
      ],
      categoryRules: [
        v => !!v || 'Kategori produk tidak boleh kosong',
      ],
      priceRules: [
        v => !!v || 'Harga produk tidak boleh kosong',
      ],
      priceB2bRules: [
        v => !!v || 'Harga produk tidak boleh kosong',
        () => parseInt(this.produkInput.hargaB2b) < parseInt(this.produkInput.hargaSatuan) || 'Harga B2B harus lebih rendah daripada harga satuan'
      ],
      stockRules: [
        v => !!v || 'Stok produk tidak boleh kosong',
      ],
      weightUnitRules: [
        v => !!v > 0 || 'Tidak boleh kosong',
      ],
      weightRules: [
        v => parseInt(v) > 0 || 'Tidak boleh kosong',
      ],
      imgPreview: [],
      produkInput: defaultInput(),
      units: ['unit', 'pcs', 'lembar', 'kotak'],
      weightUnits: [{text: 'Gram (g)', multiple: 1}, {text: 'Kilogram (Kg)', multiple: 1000}],
      productSamples: [
				{
					product_id: '103',
					product_category_id: '1',
					product_code: '',
					product_name: 'HWI-C',
					product_slug_name: 'hwi-c',
					product_pv: '0',
					product_description: 'Suplemen Vitamin C Generasi terbaru, Pureway-C, yang aman di lambung, mudah diserap dan bertahan lama di dalam tubuh sehingga dapat membantu menjaga daya tahan tubuh. Diperkaya dengan Vitamin D, Vitamin E, Zinc dan ekstrak alami Citrus Bioflavonoid, Rosehip, Acerola yang penting dalam penyerapan Vitamin C yang optimal.',
					product_image: [
						'https://gambar.healthwealthint.com/compro/2021/aset/HWI%20C%20WEB.png'
					],
					product_weight: '100',
					product_unit: 'pcs',
					product_type: 'external',
					product_internal_type: '',
					product_cashback: '0',
					product_view_count: '367',
					product_sold_count: '0',
					product_rating: '0',
					product_review_count: '0',
					product_is_active: 'active',
					product_allowed_type: '',
					store_courier: '[\'jne\',\'tiki\',\'pos\',\'jnt\']',
					product_price: 408000,
					product_price_origin: '408000',
					product_store: {
						store_id: '61',
						store_name: 'CHYMUT INDO OLSHOP',
						store_slug: 'chymut-indo-olshop',
						store_image: null,
						store_description: null,
						store_address: 'Pnakkukang Permai nomor 5',
						store_province_id: '28',
						store_province_name: 'Sulawesi Selatan',
						store_city_id: '254',
						store_city_name: 'Makassar',
						store_subdistrict_id: '3594',
						store_subdistrict_name: 'Rappocini',
						store_zipcode: '90111',
						store_latitude: '',
						store_longitude: '',
						store_bank_name: 'Mandiri',
						store_bank_branch: 'Makassar',
						store_bank_account_name: 'MUSTARI SALEH',
						store_bank_account_number: '1740002241354',
						store_rating: '0',
						store_courier: '[\'jne\',\'tiki\',\'pos\',\'jnt\']',
						store_trx_count: '0',
						store_po_count: '0',
						store_is_active: 'active',
						store_is_b2b: 'false',
						store_input_datetime: '2021-03-20 21:03:37',
						store_stock_store_id: '61',
						store_stock_product_id: '103',
						store_stock_quantity: '100'
					}
				},
				{
					product_id: '13',
					product_category_id: '1',
					product_code: '',
					product_name: 'Samori',
					product_slug_name: 'samori',
					product_pv: '0',
					product_description: 'Konsentrat cuka mengkudu yang kaya akan asam amino, vitamin dan mineral untuk membantu memelihara kesehatan tubuh. Diproses dengan teknologi khusus yang menjamin kemurnian senyawa dan khasiat mengkudu tetap terjaga.\nManfaat :\n Membantu memelihara kesehatan tubuh',
					product_image: [
						'https://asethwi.healthwealthint.com//images/news/2021/1415171523health-care-samori-000.png'
					],
					product_weight: '30',
					product_unit: 'kotak',
					product_type: 'external',
					product_internal_type: '',
					product_cashback: '0',
					product_view_count: '361',
					product_sold_count: '0',
					product_rating: '0',
					product_review_count: '0',
					product_is_active: 'active',
					product_allowed_type: '',
					store_courier: '[\'jne\',\'tiki\',\'pos\',\'jnt\']',
					product_price: 250000,
					product_price_origin: '250000',
					product_store: {
						store_id: '3',
						store_name: 'Assyifa ',
						store_slug: 'Wwwwassyifa',
						store_image: null,
						store_description: null,
						store_address: 'Jl. Waterboom no 4 ',
						store_province_id: '30',
						store_province_name: 'Sulawesi Tenggara',
						store_city_id: '182',
						store_city_name: 'Kendari',
						store_subdistrict_id: '2562',
						store_subdistrict_name: 'Wua-Wua',
						store_zipcode: '93117',
						store_latitude: '',
						store_longitude: '',
						store_bank_name: 'BCA',
						store_bank_branch: 'Kendari ',
						store_bank_account_name: 'Syarif kuengo ',
						store_bank_account_number: '7910674425',
						store_rating: '0',
						store_courier: '[\'jne\',\'tiki\',\'pos\',\'jnt\']',
						store_trx_count: '0',
						store_po_count: '0',
						store_is_active: 'active',
						store_is_b2b: 'false',
						store_input_datetime: '2020-12-21 09:06:34',
						store_stock_store_id: '3',
						store_stock_product_id: '13',
						store_stock_quantity: '99'
					}
				},
			]
    }
  },

  computed: {
    ...mapState('category', ['category']),
    ...mapState('productSeller', ['responseError', 'detailProduct']),
    ...mapState('storeSeller', ['detailStore']),

    imgProduct() {
      let img = []
      for(var i = 0; i < 5; i++ ) {
        img[i] = this.imgPreview[i] ? this.imgPreview[i].img : undefined
      }
      return img
    },
  },

  methods: {
    ...mapActions('category', ['getCategory']),
    ...mapActions('productSeller', ['addProduct', 'addProductB2b', 'uploadImage', 'getProductDetail']),
    ...mapMutations('productSeller', ['clearProduct']),
    ...mapMutations(['makeAlert']),
    ...mapActions('storeSeller', ['getStoreDetail']),

    removeImage(index) {
      this.imgPreview.splice(index, 1)
    },
    async openUpload() {
      const input = await document.getElementById('inputProdukImg')
      input.click()
    },
    createImage(event) {
      var dimensions = [];
      event.forEach((el) => {
        dimensions.push(new Promise(function (resolve) {

          var reader = new FileReader();
          reader.onload = (e) => {
            resolve({
              img: e.target.result,
              file: el
            })
          };
          reader.readAsDataURL(el);
        }));
      });

      Promise.all(dimensions).then((res) => {
        if (this.imgPreview.length + res.length > 5)
          this.makeAlert({ code: 'error_response', type: 'error', message: 'Gambar maksimal 5', show: true })

        res.splice(5 - this.imgPreview.length, res.length - 1)
        this.imgPreview = [...this.imgPreview, ...res]

        if (this.imgPreview.length > 0)
          this.image_alert = false
      }).catch(function(err) {
        console.log(err)
      })
    },
    upload(type) {
      var dimensions = []
      this.imgPreview.forEach((el) => {
        dimensions.push(new Promise( (resolve) => {
          let formData = new FormData();
          formData.append('image', el.file);
          this.uploadImage(formData).then((res) => {
            resolve(res.product_image)
          })
        }));
      });

      Promise.all(dimensions).then((dims) => {
        this.produkInput.image = dims
        let resetProduct = (type) => {
            this.$refs.formAddProduct.resetValidation()
            this.$refs.fileupload.clearableCallback()
            this.imgPreview = []
            this.produkInput = defaultInput()
            this.loadingProcess = false
            if (type === 2) this.$router.push('/seller/produk-saya')
        }
        if (this.detailStore.store_is_b2b == 'false') {
          let params = {
            category_id: this.produkInput.kategori,
            code: this.produkInput.code,
            name: this.produkInput.nama,
            description: this.produkInput.deskripsi,
            price: this.produkInput.hargaSatuan,
            weight: this.produkInput.berat * this.produkInput.unitberat,
            unit: this.produkInput.unit,
            quantity: this.produkInput.stok,
            status: this.produkInput.status,
            image: this.produkInput.image,
          }
          this.addProduct(params).then( () => {
            resetProduct(type)
          }).catch(() => {
            this.loadingProcess = false
          })
        } else if (this.detailStore.store_is_b2b == 'true') {
          let params = {
            category_id: this.produkInput.kategori,
            code: this.produkInput.code,
            name: this.produkInput.nama,
            description: this.produkInput.deskripsi,
            price: this.produkInput.hargaSatuan,
            price_original: this.produkInput.hargaB2b,
            weight: this.produkInput.berat * this.produkInput.unitberat,
            unit: this.produkInput.unit,
            quantity: this.produkInput.stok,
            status: this.produkInput.status,
            image: this.produkInput.image,
          }
          this.addProductB2b(params).then( () => {
            resetProduct(type)
          }).catch(() => {
            this.loadingProcess = false
          })
        }
      }).catch(function(err){
        console.log(err)
        this.loadingProcess = false
      })
    },
    async save(type) {
      if (this.$refs.formAddProduct.validate()) {
        this.loadingProcess = await true
        if (this.imgPreview.length > 0) {
          this.image_alert = false
          await this.upload(type)
        } else {
          this.image_alert = true
          this.loadingProcess = false
        }
      }
    },
    cancelForm() {
      this.$router.push('/seller/produk-saya')
    },
    toggleAlert(val) {
      this.image_alert = val
    },
    onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
        this.isMobile = false;
    },
  },
  created() {
    this.$store.dispatch('setPageTitle', `Tambah Produk`);
    this.getStoreDetail()
    this.getCategory()
  },
  beforeDestroy() {
    this.clearProduct()
  }
}
</script>

<style lang="scss" scoped>
  .product-img {
    border: 2px solid green;
    border-radius: 4px;

    &.emptyImg {
      border: 2px solid #ddd;
    }
  }
  .product-img {
    position: relative;
    .close-btn {
      position: absolute;
      top: -15px;
      right: -15px;
      height: 28px;
      width: 28px;
    }
  }
</style>